/**
 * Hues.js — Built-in directives
 * -----------------------------------------------------------------------------
 * Implements the canonical directive set used by Hues.js templates:
 *   v-if, v-else-if, v-else, v-for, v-show, v-model, v-bind, v-on,
 *   v-text, v-html, v-once, v-pre, v-cloak.
 *
 * Most directives are handled inline by the template compiler in `compiler.ts`,
 * but a handful of "hook-style" directives (show, model, focus, cloak) are
 * exported here as reusable definitions and registered with the renderer.
 *
 * © Death Legion — Hues.js
 */

import { DirectiveDefinition, registerDirective } from './compiler'

export const vShow: DirectiveDefinition = {
  beforeMount(el, { value }) {
    el.style.display = value ? '' : 'none'
  },
  updated(el, { value, oldValue }) {
    if (value !== oldValue) el.style.display = value ? '' : 'none'
  },
}

export const vModel: DirectiveDefinition = {
  mounted(el, { value }) {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      el.value = String(value ?? '')
    }
  },
  updated(el, { value }) {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      if (el.value !== String(value)) el.value = String(value ?? '')
    }
  },
}

export const vFocus: DirectiveDefinition = {
  mounted(el) {
    if (el instanceof HTMLElement) el.focus()
  },
}

export const vCloak: DirectiveDefinition = {
  beforeMount(el) {
    el.removeAttribute('v-cloak')
  },
}

export function registerBuiltinDirectives(): void {
  registerDirective('show', vShow)
  registerDirective('model', vModel)
  registerDirective('focus', vFocus)
  registerDirective('cloak', vCloak)
}

// Re-export commonly used directives for advanced use cases.
export { registerDirective } from './compiler'
